{
  "add_banner": "Add banner",
  "change_avatar": "Change avatar",
  "change_banner_image": "Change banner image",
  "remove_banner": "Remove banner",
  "remove_banner_image": "Remove banner image",
  "search_unsplash_banner": "Search Unsplash for banner image",
  "profile": "Profile",
  "profile_folder": "Profile Folder"
}